import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';
import { usePageTitle } from '../hooks/usePageTitle';

export default function Photos() {
  const [albums, setAlbums] = useState([]);
  const [thumbnails, setThumbnails] = useState({});
  const [counts, setCounts] = useState({});
  usePageTitle('Photos');

  useEffect(() => {
    async function load() {
      const [{ data: albumData }, { data: photoData }] = await Promise.all([
        supabase.from('albums').select('*').order('created_at', { ascending: false }),
        supabase.from('photos').select('id, url, album_id').order('created_at', { ascending: true }),
      ]);
      setAlbums(albumData || []);

      const thumbs = {};
      const cnts = {};
      (photoData || []).forEach(p => {
        if (!thumbs[p.album_id]) thumbs[p.album_id] = p.url;
        cnts[p.album_id] = (cnts[p.album_id] || 0) + 1;
      });
      setThumbnails(thumbs);
      setCounts(cnts);
    }
    load();
  }, []);

  return (
    <main style={{ paddingTop: '52px' }}>
      <div style={{ padding: '2.5rem' }}>
        {albums.length === 0 ? (
          <p style={{ fontSize: 'var(--t-body)', color: 'var(--ink-faint)' }}>No albums yet.</p>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
            gap: '2px',
          }}>
            {albums.map(album => (
              <Link
                key={album.id}
                to={`/album/${album.slug}`}
                style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
              >
                <div
                  style={{ aspectRatio: '1', background: 'var(--bg-2)', overflow: 'hidden' }}
                  onMouseEnter={e => { const img = e.currentTarget.querySelector('img'); if (img) img.style.opacity = '0.85'; }}
                  onMouseLeave={e => { const img = e.currentTarget.querySelector('img'); if (img) img.style.opacity = '1'; }}
                >
                  {thumbnails[album.id] && (
                    <img
                      src={thumbnails[album.id]}
                      alt=""
                      loading="lazy"
                      style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block', transition: 'opacity 200ms' }}
                    />
                  )}
                </div>
                <div style={{ paddingTop: '0.6rem', paddingBottom: '1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                  <span style={{ fontSize: 'var(--t-body)' }}>{album.name}</span>
                  <span style={{ fontSize: 'var(--t-label)', color: 'var(--ink-faint)' }}>
                    {counts[album.id] || 0}
                  </span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
